/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeMatchers } from 'ts-adt/MakeADT.js';
import { dual } from '../function/dual.js';
export * from 'effect/Data';
export const matchOn = (discriminant) => {
    const [_match, _matchP, _matchI, _matchPI] = makeMatchers(discriminant);
    return Object.assign(_match, {
        I: _matchI,
        P: _matchP,
        PI: _matchPI,
    });
};
export const match = matchOn('_tag');
export const matchFor = () => {
    return Object.assign(dual(2, (member, matchers) => matchers[member['_tag']](member)), {
        partial: dual(3, (member, matchers, rest) => matchers[member['_tag']]?.(member) ?? rest(member)),
    });
};
const capitalize = (str) => (str.charAt(0).toUpperCase() + str.slice(1));
/**
 *
 * @example
type Union = 'asd' | 'qwe'

const matchUnion = matchString<OrderType>();

const match = matchUnion({ //=> (union: Union) => false | 'asd'
  onAsd: (x) => x,
  //      ^? 'asd'
  onQwe: () => false,
  // \@ts-expect-error
  onXXX: (s) => 67,
});
*/
export const matchString = () => {
    return dual(2, (value, matcher) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        return matcher[`on${capitalize(value)}`](value);
    });
};
//# sourceMappingURL=Data.js.map